module.exports = __webpack_public_path__ + "static/media/GPG601A_F01_RL.351673cf.jpg";